<template>
  <span
    class="inline-flex items-center justify-center bg-black text-white rounded-[0.214rem] h-[2em] leading-[1.5] pl-3 pr-2 whitespace-nowrap text-[0.857rem]"
  >
    {{ label }}

    <Button
      type="button"
      id="remove-filter-btn"
      title="Remove selected filter"
      aria-label="Remove selected filter"
      class="button"
      @click="emitRemove"
      theme="DARK"
      size="nopadding"
      :outlined="true"
      :border="false"
    >
      <Icon
        icon="close"
        packPrefix="far"
        class="text-white !h-[0.975rem] w-[0.975rem] pl-[0.25rem] cursor-pointer"
      />
    </Button>
  </span>
</template>

<script setup lang="ts">
import Button from './button.vue'
import Icon from '../atom/icon.vue'
import type { TagProps, TagEmits } from '~~/shared/types/common'

const props = defineProps<TagProps>()
const emit = defineEmits<TagEmits>()

const emitRemove = () => {
  emit('remove', props.label)
}
</script>
